// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"IntermediariesConfiguration_pageContent__xoRN5","footer":"IntermediariesConfiguration_footer__3AZx0"};